/**
 * API client: adds Authorization Bearer token to requests.
 */
import { getOrCreateConversationId, setConversationId } from '../utils/sentryLogger';

let explicitConversationId: string | null = null;

export function setApiConversationId(conversationId: string): void {
  explicitConversationId = conversationId;
  setConversationId(conversationId);
}

const getConversationId = (): string => explicitConversationId ?? getOrCreateConversationId();

export const getApiConversationId = (): string => getConversationId();

export async function apiFetch(
  url: string,
  options: RequestInit & { token?: string | null } = {}
): Promise<Response> {
  const { token, ...rest } = options;
  const headers = new Headers(rest.headers);
  headers.set('X-Conversation-ID', getConversationId());
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (rest.body && typeof rest.body === 'string' && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  return fetch(url, { ...rest, headers });
}
